"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("./configuration");
var planeditor_1 = require("./planeditor");
var planeditor_2 = require("./planeditor");
var FilterLevelCalculator_1 = require("./datalayer/FilterLevelCalculator");
function generateNumeral(value, theColumn) {
    if (!isNaN(value)) {
        var theSettings = theColumn.settings;
        var theNumberFormat = theSettings && theSettings.numberFormat;
        if (theColumn.dataType === planeditor_1.DATA_TYPES.NUMBER || theColumn.dataType === planeditor_1.DATA_TYPES.CURRENCY) {
            var factor = theColumn.settings ? theColumn.settings.factor : undefined;
            value = typeof factor !== "undefined" ? value * factor : value;
        }
        if (theColumn.dataType === planeditor_1.DATA_TYPES.NUMBER && theNumberFormat) {
            value = numeral(value).format(theNumberFormat);
        }
    }
    else {
        value = configuration_1.PlanConfiguration.ERROR_STRING;
    }
    return value;
}
exports.totalRowViewProviderClass = zebra.Class(zebra.ui.grid.DefViews, [
    function () {
        this.standardFont = new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, configuration_1.PlanConfiguration.fontSize);
        this.$super();
    },
    function setColumnSet(columnSet) {
        this.columns = columnSet.columns.map(function (column) {
            return column || {};
        });
    },
    function getXAlignment(grid, row, col) {
        var zebraAlignment;
        if (this.columns[col].settings) {
            switch (this.columns[col].settings.xAlign) {
                case planeditor_2.HORIZONTAL_ALIGNMENTS.LEFT:
                    zebraAlignment = zebra.layout.LEFT;
                    break;
                case planeditor_2.HORIZONTAL_ALIGNMENTS.CENTER:
                    zebraAlignment = zebra.layout.CENTER;
                    break;
                case planeditor_2.HORIZONTAL_ALIGNMENTS.RIGHT:
                    zebraAlignment = zebra.layout.RIGHT;
                    break;
                default:
                    zebraAlignment = zebra.layout.LEFT;
            }
        }
        else {
            zebraAlignment = zebra.layout.CENTER;
        }
        return zebraAlignment;
    },
    function getYAlignment(grid, row, col) {
        return zebra.layout.CENTER;
    },
    function getView(grid, row, col, value) {
        var theColumn = this.columns[col];
        if (theColumn.dataType === planeditor_1.DATA_TYPES.NUMBER) {
            value = generateNumeral(value, theColumn);
        }
        if (theColumn.dataType === planeditor_1.DATA_TYPES.BOOLEAN ||
            value === null || value === undefined ||
            value === configuration_1.PlanConfiguration.ERROR_STRING) {
            value = "";
        }
        if (theColumn.editor && theColumn.editor.config && value === theColumn.editor.config.defaultValue) {
            value = "";
        }
        if (this.rows && this._limitValue) {
            var theRow = this.rows[row];
            var minLevel = _.get(theColumn, "settings.level");
            if (minLevel) {
                var thisLevel = FilterLevelCalculator_1.FilterLevelCalculator.calculateLevel(_.get(theRow, "rawSample"), this._limitValue);
                if (thisLevel < minLevel) {
                    return this.createCompRender(configuration_1.PlanConfiguration.limitationText);
                }
            }
        }
        var theLabel = new zebra.ui.Label(value.toString());
        theLabel.setFont(this.standardFont);
        theLabel.setColor(configuration_1.PlanConfiguration.tableColor);
        var thePanel = new zebra.ui.Panel(new zebra.layout.FlowLayout());
        thePanel.setPadding(configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding, configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding);
        thePanel.add(theLabel);
        return new zebra.ui.CompRender(thePanel);
    },
    function setLimitValue(value) {
        this._limitValue = value;
    },
    function createCompRender(value) {
        if (!value) {
            value = "";
        }
        var theLabel = new zebra.ui.Label(value.toString());
        theLabel.setColor(configuration_1.PlanConfiguration.tableColor);
        return this.createPanel(theLabel);
    },
    function createPanel(label) {
        var thePanel = new zebra.ui.Panel(new zebra.layout.FlowLayout());
        thePanel.setPadding(configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding, configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding);
        thePanel.add(label);
        return new zebra.ui.CompRender(thePanel);
    },
]);
//# sourceMappingURL=TotalRowViewProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/TotalRowViewProvider.js
// module id = 36
// module chunks = 0